// extracted by mini-css-extract-plugin
export default {"verificationText":"ResetPasswordModal_verificationText__70ReM"};